import React from 'react';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';
import { StockOpname } from 'services/action';

const initialState = {
  file: null,
  temp: [],
};

export const FormBulkImport = ({ setItems }) => {
  const Dispatch = useDispatch();
  const ref = React.useRef(null);

  const [{ file }, setState] = React.useState(initialState);
  const $handleImport = async (blob) => {
    setState((prevState) => ({
      ...prevState,
      file: blob,
    }));

    const promise = new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (blob) {
        reader?.readAsArrayBuffer(blob);
        reader.onload = async function (e) {
          const buffer = e?.target?.result;
          const wb = XLSX?.read(buffer, { type: 'buffer' });
          const wsname = wb?.SheetNames[0];
          const ws = wb?.Sheets[wsname];
          const data = XLSX?.utils?.sheet_to_json(ws);
          resolve(data);
        };

        reader.onerror = (error) => {
          reject(error);
        };
      }
    });

    promise.then(async (data) => {
      if (data) {
        let array = data;

        let it = [];
        for (let i = 0; i < array?.length; i++) {
          let payload = {
            item_id: array[i]?.ITEM_ID,
            current_stock: parseFloat(array[i]?.STOCK_AVAILABLE || 0),
            quantity: parseFloat(array[i]?.OPNAME_QUANTITY || 0),
            quantity_defect: parseFloat(array[i]?.DEFECT_QUANTITY || 0),
            unit_name: array[i]?.UNIT_NAME,
          };

          it?.push(payload);

          setState((prevState) => ({
            ...prevState,
            temp: [
              ...prevState?.temp,
              {
                item_id: array[i]?.ITEM_ID,
                current_stock: parseFloat(array[i]?.STOCK_AVAILABLE),
                quantity: parseFloat(array[i]?.OPNAME_QUANTITY),
                quantity_defect: parseFloat(array[i]?.DEFECT_QUANTITY),
                unit_name: array[i]?.UNIT_NAME,
              },
            ],
          }));
        }

        setItems(it);
      }
    });
  };

  return (
    <div className="border-bottom pb-3 d-flex flex-column flex-wrap mb-3">
      <div className="pb-3">
        <div className="fw-semibold " style={{ fontSize: 13 }}>
          Bulk Import{' '}
          <span
            className="text-primary cursor-pointer"
            onClick={() => Dispatch(StockOpname.$download())}
          >
            (Download Template)
          </span>
        </div>
      </div>
      <div className="me-0 me-md-3">
        <div
          className="input-group mb-2 cursor-pointer"
          onClick={() => {
            ref?.current?.click();
          }}
        >
          <span className="input-group-btn btn btn-light border">
            Upload File
          </span>
          <div className="form-control"> {file?.name}</div>
          <input
            ref={ref}
            type="file"
            onChange={(e) => {
              $handleImport(e?.target?.files[0]);
            }}
            className="form-control d-none"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
    </div>
  );
};
